(() => {
  try {
    const VIEW_KEY = 'pdp_session_view';
    const HANDLES_KEY = 'pdp_session_handles';
    const ORIGIN_HANDLE_KEY = 'pdp_session_origin_handle';
    const ALLOWED_VIEWS = new Set(['new-pdp', 'new-pdp-experiment']);
    const isDesignMode = !!(window.Shopify && window.Shopify.designMode);

    const currentUrl = new URL(window.location.href);
    const currentView = String(currentUrl.searchParams.get('view') || '').toLowerCase();
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    const currentHandle = match ? String(match[1] || '').toLowerCase() : '';

    function readHandles() {
      try {
        const arr = JSON.parse(sessionStorage.getItem(HANDLES_KEY) || '[]');
        if (!Array.isArray(arr)) return [];
        return arr.map((x) => String(x || '').toLowerCase()).filter(Boolean);
      } catch (_) {
        return [];
      }
    }

    function writeHandles(list) {
      const uniq = Array.from(new Set((list || []).map((x) => String(x || '').toLowerCase()).filter(Boolean)));
      sessionStorage.setItem(HANDLES_KEY, JSON.stringify(uniq));
      return uniq;
    }

    function captureHandlesFromConfig() {
      const node = document.querySelector('script[data-offer-v2-config]');
      if (!node) return;
      try {
        const cfg = JSON.parse(node.textContent || '{}');
        const eligible = Array.isArray(cfg.eligibleProductHandles) ? cfg.eligibleProductHandles : [];
        writeHandles([currentHandle, ...eligible]);
      } catch (_) {}
    }

    // Store active experiment view for session.
    if (ALLOWED_VIEWS.has(currentView)) {
      sessionStorage.setItem(VIEW_KEY, currentView);
      if (currentHandle) {
        if (!sessionStorage.getItem(ORIGIN_HANDLE_KEY)) {
          sessionStorage.setItem(ORIGIN_HANDLE_KEY, currentHandle);
        }
        const existing = readHandles();
        if (!existing.includes(currentHandle)) writeHandles([currentHandle, ...existing]);
      }
      if (currentHandle) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', captureHandlesFromConfig, { once: true });
        } else {
          captureHandlesFromConfig();
        }
      }
    }

    const storedView = String(sessionStorage.getItem(VIEW_KEY) || '').toLowerCase();
    if (!ALLOWED_VIEWS.has(storedView)) return;

    const originHandle = String(sessionStorage.getItem(ORIGIN_HANDLE_KEY) || '').toLowerCase();
    const handles = readHandles();
    const inEligibleGroup = !!currentHandle && (handles.includes(currentHandle) || currentHandle === originHandle);

    // If user returns to eligible product without view, restore it.
    if (!isDesignMode && inEligibleGroup && !currentUrl.searchParams.get('view')) {
      currentUrl.searchParams.set('view', storedView);
      window.location.replace(currentUrl.toString());
      return;
    }

    // Ensure links to eligible products carry the stored view.
    const links = document.querySelectorAll('a[href*="/products/"]');
    links.forEach((a) => {
      try {
        const next = new URL(a.getAttribute('href'), window.location.origin);
        const m = next.pathname.match(/^\/products\/([^/?#]+)/);
        const handle = m ? String(m[1] || '').toLowerCase() : '';
        const linkIsEligible = !!handle && (handles.includes(handle) || handle === originHandle);
        if (!linkIsEligible) return;
        if (!next.searchParams.get('view')) {
          next.searchParams.set('view', storedView);
          a.setAttribute('href', next.pathname + next.search + next.hash);
        }
      } catch (_) {}
    });
  } catch (e) {
    console && console.warn && console.warn('new-pdp view session failed', e);
  }
})();
